import component from './zh-CN/component';
import globalHeader from './zh-CN/globalHeader';
import global from './zh-CN/global';
import menu from './zh-CN/menu';
import pages from './zh-CN/pages';
import fields from './zh-CN/fields';
import pwa from './zh-CN/pwa';
import settingDrawer from './zh-CN/settingDrawer';
import settings from './zh-CN/settings';
import order from './zh-CN/order';

export default {
  'navBar.lang': '语言',
  'layout.user.link.help': '帮助',
  'layout.user.link.privacy': '隐私',
  'layout.user.link.terms': '条款',
  'app.preview.down.block': '下载此页面到本地项目',
  'app.welcome.link.fetch-blocks': '获取全部区块',
  'app.welcome.link.block-list': '基于 block 开发，快速构建标准页面',
  ...pages,
  ...globalHeader,
  ...global,
  ...menu,
  ...settingDrawer,
  ...settings,
  ...pwa,
  ...component,
  ...fields,
  ...order,
};
